<template>
    <div-unit unitTitle="Code & Software Download" style="margin-bottom: 50px">
      

     
      <p class="title">Code Availability</p>
      <p>
        You can reach the code by GitHub at:
        <a href="https://github.com/idrblab/MELO" target="_blank"
          >https://github.com/idrblab/MELO</a
        >
      </p>
      <p class="title">Program Availability</p>
      <p>
        Click
        <a :href="`${domain_name}/files/download/MELO.rar`" target="_blank"
          ><b>MELO.rar</b></a
        >
        to download the local version of the program. You can use
        <i>MELO</i> for batch calculations on your Windows system.
      </p>
      <p class="title">Program Usage</p>
      <p>
        After extraction
        <a :href="`${domain_name}/files/download/MELO.rar`" target="_blank"
          ><b>MELO.rar</b></a
        >, click <span class="color-blue">MELO.exe</span> to launch the application.
      </p>

      <div style="padding: 23px 50px 50px 50px">
        <el-image lazy :src="`${domain_name}/files/download/image1.png`" style="width: 60%" />
      </div>
      <p>
        <span class="xiahuaxian">Step 1:</span> Specify the <b>PDB folder path</b> containing all structural files (<i>PDB/PDBx/mmCIF</i> formats) for batch analysis.
      </p>
      <p>
        <span class="xiahuaxian">Step 2:</span> Provide the <b>protein pair path</b> - a <b>CSV</b> file defining target protein pairs, their chains and alignment.
      </p>
      <p>
        <b class="color-red">!!!Attention</b>: ① Multiple chains must be separated by <span class="color-red">semicolons (;)</span>;
        ② Either <span class="color-red">SW (Smith Waterman)</span> or <span class="color-red">US (US-align)</span>
        can be selected as the sequence alignment method. If no method is specified, the sequence similarity of the protein pair will be automatically calculated. Smith Waterman will be used for pairs with similarity ≥30%; otherwise, US-align will be applied, as shown below:
      </p>

      <div style="padding: 23px 50px 50px 50px">
        <el-image lazy :src="`${domain_name}/files/download/image2.png`" style="width: 60%" />
      </div>
      <p>
        <span class="xiahuaxian">Step 3:</span> Select the <b>output folder path</b> for storing results.
      </p>

      <p>
        Click the <b>Calculate</b> button to initiate processing. The system will automatically:
        <ul>
          <li>
            Create individual result folders for each protein pair
          </li>
          <li>
            Generate two location plots:
            <br>
            - <b>PLOT<sup style="font-style: italic;">VSS</sup></b>: Location of Variations in Secondary Structure
            <br>
            - <b>PLOT<sup style="font-style: italic;" >SPS</sup></b>: Location of Shifts among Protein segments
          </li>
          
          <li>
            Data Interpretation Guidance:
            <br>
            - The coordinate axes display the distribution of protein pair scores within the SC<i>in</i>SV 
            <br>
            - A threshold of 0.5 is applied to determine: 
            <ul>
              <li>
                Scores ≥ 0.5: Variations in Secondary Structure and/or Shifts among Protein segments
              </li>
              <li>
                Scores &lt; 0.5: Similarity in Secondary Structure and/or among Protein segments
              </li>
            </ul>
          </li>


          <li>
            Save quantitative measurements (<i style="font-weight: bold;">VSS<sub>measur</sub></i> and <i style="font-weight: bold;">SPS<sub>measur</sub></i>) in <b>melo_results.csv</b>
          </li>
        </ul>
      </p>
      <div style="padding: 23px 50px 50px 50px">
        <el-image lazy :src="`${domain_name}/files/download/image3.png`" style="width: 60%" />
      </div>

     
    </div-unit>
</template>
  
  <script>
import DivUnit from "@/components/DivUnit.vue";
// import api from "../api/index";
import pathUrl from "@/api/path";
export default {
  name: "DownloadDate",
  data() {
    return {
      domain_name: pathUrl.localUrl,
    };
  },
  components: {
    DivUnit,
  },

  methods: {},

  beforeMount() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.xiahuaxian {
  text-decoration: underline;
}
.color-red {
  color: red;
}
.color-blue,
a {
  color: blue;
}
.suojin {
  list-style-type: disc;
  padding-left: 45px;
}
.title {
  font-weight: bold;
}
p {
  margin: 15px 0;
  text-align: left;
}
/deep/.div-content {
  border-top: 0px solid #2c3e50;
}
</style>
  